import React from "react";
import mapPin from "./images/map-pin.svg";

const PrefixIcon = () => {
    return <img src={mapPin} alt={"Map pin"} height={20} width={20}/>;
};

export default PrefixIcon;
